export enum RestrictionTypes {
  allow = 'allow',
  notAllow = 'notAllow',
}
